export default {
  appName: "",
  theme: {
    primaryColor: "#3498db",
    secondaryColor: "#2ecc71",
  },
  mainCollection: "",
  roles: [],
  screens: [],
  database: [],
};
